import React from 'react'
import SearchField from '../../formFields/searchField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <SearchField {...fieldProps} />
))
